import { api } from '../DefaultService';
import { ILicenseSimpleProps } from './types';

const ENDPOINT = '/v1/licenses';

export const createLicensesAsync = async (): Promise<void> => {};

export const getAllLicensesAsync = async (): Promise<ILicenseSimpleProps[]> => {
  return await api
    .get<ILicenseSimpleProps[]>(ENDPOINT)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getLicenseByIdAsync = async (
  id: string,
): Promise<ILicenseSimpleProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateLicenseAsync = async (): Promise<void> => {};

export const deleteLicenseAsync = async (): Promise<void> => {};

// const convertPlansNames = (plans: IPlans) => {
//   switch(plans) {
//     case
//   }
// };
